import { Money, TaxRate, TaxStrategy } from '@principle-theorem/accounting';
import { determineTaxFromStrategy } from '@principle-theorem/principle-core';
import {
  InvoiceLineItemType,
  type IFeeLineItem,
} from '@principle-theorem/principle-core/interfaces';
import { type IPraktikaAppointmentInvoiceAdjustment } from '../../../source/entities/appointment-invoice-adjustment';
import { PraktikaTransationType } from '../../../source/entities/appointment-invoice-payment';

export type IPraktikaSurchargeAdjustment = Pick<
  IPraktikaAppointmentInvoiceAdjustment,
  'id' | 'type_id' | 'description' | 'notes' | 'amount'
>;

export class PraktikaSurcharge {
  static isSurcharge(adjustment: IPraktikaSurchargeAdjustment): boolean {
    return [
      PraktikaTransationType.SurchargeDr,
      PraktikaTransationType.SurchargeCr,
    ].includes(adjustment.type_id);
  }

  /**
   * Reversals (`SurchargeCr`) become negative fees so that they net off against
   * the `SurchargeDr` they were raised against on the same invoice.
   */
  static toFeeLineItem(
    adjustment: IPraktikaSurchargeAdjustment,
    taxRate: TaxRate,
    taxStatus: TaxStrategy
  ): IFeeLineItem {
    const charged = Math.abs(Money.fromCents(adjustment.amount));
    const amount =
      adjustment.type_id === PraktikaTransationType.SurchargeCr
        ? -charged
        : charged;

    return {
      uid: adjustment.id.toString(),
      type: InvoiceLineItemType.Fee,
      description: [adjustment.description, adjustment.notes]
        .filter((item) => item !== '')
        .join(' - '),
      amount,
      tax: determineTaxFromStrategy(taxRate, { taxStatus, amount }),
      taxStatus,
      quantity: 1,
    };
  }
}
